import * as React from "react";
import { makeStyles } from "@mui/styles";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { logoNameToPath } from "../constants/logos";
import useTranslation from "../hooks/translations";
import { getProviderServiceCharge } from "../utils/paymentCharges";

const useStyles = makeStyles((theme: any) => ({
  image: {
    width: 30,
    height: 20,
  },
  paymentMethodName: {
    flexGrow: 3,
    fontWeight: 500,
    fontSize: 14,
    textAlign: "left",
    alignSelf: "left",
    width: "100%",
  },
  paymentOption: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 10,
    width: "100%",
    border: "solid 1px #E0E0E0",
    padding: "9px 10px",
    borderRadius: 10,
    marginTop: 20,
    transition: "background-color 0.3s ease, box-shadow 0.3s ease",
    "&:hover": {
      backgroundColor: "#F5F5F5",
      boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
      cursor: "pointer",
    },
  },
}));

interface PaymentProvider {
  name: string;
  paymentOptions?: Array<{ paymentProviderInfo?: { name?: string } }>;
}

interface PaymentOptionProps {
  paymentProvider: PaymentProvider;
  onClick: (paymentProvider: PaymentProvider, optionChangeObject: any) => void;
  dataTestId: string;
  optionChangeObject: any;
  selectedProviderId?: string;
  currency?: string | null;
  children: any;
}

const PaymentOption: React.FC<PaymentOptionProps> = ({
  paymentProvider,
  onClick,
  optionChangeObject,
  dataTestId,
  selectedProviderId,
  currency,
  children,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const isSingleFlocash =
    paymentProvider.paymentOptions?.length === 1 &&
    paymentProvider.paymentOptions[0]?.paymentProviderInfo?.name === "flocash";

  const serviceCharge = getProviderServiceCharge(
    paymentProvider,
    selectedProviderId,
  );
  const isFree = !serviceCharge;

  const translatedPaymentOptions: any = {
    Paypal: t("paypal"),
    "Mobile Money": t("mobileMoney"),
    Card: t("creditCard"),
  };

  return (
    <>
      <div
        className={classes.paymentOption}
        onClick={(e) => onClick(paymentProvider, optionChangeObject)}
        data-testid={dataTestId}
      >
        <div>
          <img
            src={logoNameToPath[paymentProvider.name]}
            alt={paymentProvider.name}
            className={classes.image}
          />
        </div>
        <p className={classes.paymentMethodName}>
          {translatedPaymentOptions[paymentProvider.name]}
        </p>

        <div>
          {isSingleFlocash ? (
            <KeyboardArrowRightIcon fontSize="small" color="inherit" />
          ) : paymentProvider.name === optionChangeObject.providerType ? (
            <KeyboardArrowDownIcon fontSize="small" color="inherit" />
          ) : (
            <KeyboardArrowDownIcon fontSize="small" color="inherit" />
          )}
        </div>
      </div>
      {!isSingleFlocash &&
        paymentProvider.name === optionChangeObject.providerType &&
        children}
    </>
  );
};

export default PaymentOption;
